import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { motion } from "framer-motion";

import logo from "../../images/logo.svg";
import arrowLeft from "../../images/icons/arrow-left.svg";
import newsletterImg from "../../images/newsletter.png";

import "../../css/header.css";

const Header = (props) => {
    const [resources, setResources] = useState({});

    let navigate = useNavigate();
    const { language } = useParams();

    const selectLanguageOptions = [
        { value: 'de', label: 'DE' },
        { value: 'en', label: 'EN' }
    ];

    let languageNavPath = props.pagePath || "home";
    let isConfirmationPage = props.isConfirmationPage || false;

    let eventId = props.eventId;
    let eventName = props.eventName;
    let eventDate = props.eventDate;
    let eventStartTime = props.eventStartTime;
    let eventCity = props.eventCity;
    let eventLocation = props.eventLocation;

    useEffect(() => {
        requestResources();
    }, [language]);

    const requestResources = async () => {
        try {
            const res = await axios.get(`form/resources/${language}`);
            setResources(res.data?.translation);
        } catch (error) {
            console.error(error?.response?.data);
        }
    };

    const handleLanguageSwitch = (lang) => {
        if (lang !== language && languageNavPath === "home") {
            navigate(`/${lang}/${languageNavPath}/${eventId}`);
        }

        if (lang !== language && languageNavPath !== "home") {
            navigate(`/${lang}/${languageNavPath}`);
        }
    };

    const ShopbasketIcon = () => {
        return (
            props.isShoppingCartVisible && (
                <div className="d-flex align-items-center justify-content-end">
                    <div
                        className={`nav-shop-basket-container ${props.numberOfTickets > 0 ? 'cursor-pointer' : ''}`}
                        onClick={props.numberOfTickets > 0 ? () => navigate(`/${language}/shipping`) : undefined}
                    >
                        <svg
                            fill="#ffffff"
                            className="nav-shop-basket"
                            viewBox="0 -32 576 576"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path d="M528.12 301.319l47.273-208C578.806 78.301 567.391 64 551.99 64H159.208l-9.166-44.81C147.758 8.021 137.93 0 126.529 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24h69.883l70.248 343.435C147.325 417.1 136 435.222 136 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-15.674-6.447-29.835-16.824-40h209.647C430.447 426.165 424 440.326 424 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-22.172-12.888-41.332-31.579-50.405l5.517-24.276c3.413-15.018-8.002-29.319-23.403-29.319H218.117l-6.545-32h293.145c11.206 0 20.92-7.754 23.403-18.681z" />
                        </svg>
                    </div>
                    {props.numberOfTickets > 0 && (
                        <span className="cart-quantity">
                            {props.numberOfTickets}
                        </span>
                    )}
                </div>
            )
        );
    };


    return (
        <header className="header-swiss-orchestra container-fluid pb-5">
            <div className="row">

                {/* Left column */}
                <div className="col d-flex flex-column header-left align-items-start justify-content-start">

                    <div className="d-flex align-items-center mb-2" style={{ width: "100%" }} >

                        {/* Logo mobile */}
                        <a href={resources?.SwissorchestraUrl} className="visible-mobile">
                            <img src={logo} alt="Logo" className="logo" />
                        </a>

                        {/* Language */}
                        <div className="visible-desktop" style={{ minWidth: 60 }}>
                            <select
                                className='language-select white-arrow-select'
                                value={language}
                                onChange={(e) => handleLanguageSwitch(e.currentTarget.value)}
                            >
                                <option value="de">de</option>
                                <option value="en">en</option>
                            </select>

                        </div>

                        {/* Divider */}
                        <div className="navbar-divider-horizontal visible-desktop" />

                        {/* Swiss Orchestra Button */}
                        <div className="div-swissorchestra">
                            <a href={resources?.SwissorchestraUrl} className="button-header">
                                SWISS ORCHESTRA
                            </a>
                        </div>

                        <div className="visible-mobile ms-auto">
                            {ShopbasketIcon()}
                        </div>
                    </div>

                    {/* To All Concerts Buttons */}
                    <div className="div-allconcerts">
                        {/*<div className="button-allconcerts-wrapper d-flex mb-2">*/}
                        {/*    <a href="https://swiss-orchestra.webflow.io/konzerte/tell-swiss-legend-21-11-2025#"*/}
                        {/*        className="button-allconcerts-arrow me-2"*/}
                        {/*    >*/}
                        {/*        <img src={arrowLeft} alt="To All Concerts" style={{ marginTop: "-3px", width: "8px" }} />*/}
                        {/*    </a>*/}
                        {/*    <a href="https://swiss-orchestra.webflow.io/konzerte/tell-swiss-legend-21-11-2025#" className="button-allconcerts">*/}
                        {/*        {resources?.AllConcerts}*/}
                        {/*    </a>*/}
                        {/*</div>*/}

                        {/* Promotion Code */}
                        {/*<div className="row">*/}
                        {/*    <div className="col-auto">*/}
                        {/*        <input type="text" className="form-control textbox-promocode" placeholder={resources.HeaderPromocodeEnter} />*/}
                        {/*    </div>*/}
                        {/*    <div className="col-auto mt-auto">*/}
                        {/*        <button className="button-promocode">*/}
                        {/*            {resources?.HeaderRedeem}*/}
                        {/*        </button>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                    </div>
                </div>

                {/* Center column */}
                <div className="col d-flex flex-column text-center header-center justify-content-start">
                    {/* Logo desktop */}
                    <a href={resources?.SwissorchestraUrl} className="visible-desktop">
                        <img src={logo} alt="Logo" className="logo" />
                    </a>

                    {!isConfirmationPage &&
                        <>
                            {/* Event Date, Time, Location */}
                            <div className="text-white mt-5">
                                <motion.div
                                    className="d-flex justify-content-center flex-wrap gap-2 text-date-location"
                                    initial={{ opacity: 0, y: 30 }}   // start: invisible + lower
                                    animate={{ opacity: 1, y: 0 }}    // end: visible + in place
                                    transition={{ duration: 0.5, ease: "easeOut" }}
                                >
                                    <span className="fw-bold">{eventDate}</span>
                                    <span className="text-fade">{eventStartTime}</span>
                                    <span className="fw-bold text-uppercase">{eventCity}</span>
                                    <span className="text-fade text-uppercase">{eventLocation}</span>
                                </motion.div>
                            </div>

                            {/* Event Name */}
                            <div className="text-white mt-2">
                                <motion.div
                                    className="d-flex justify-content-center flex-wrap gap-3n"
                                    initial={{ opacity: 0, y: 30 }}   // start: invisible + lower
                                    animate={{ opacity: 1, y: 0 }}    // end: visible + in place
                                    transition={{ duration: 0.5, ease: "easeOut", delay: 0.6 }}
                                >
                                    <span className="event-name">{eventName}</span>
                                </motion.div>
                            </div>
                        </>
                    }
                </div>

                {/* Right column */}
                <div className="visible-desktop col d-flex flex-column header-right align-items-end justify-content-start">

                    <div className="d-flex align-items-center justify-content-end mb-2">
                        <a href={resources?.HeaderConcertsAndTicketsUrl} className="button-header">
                            {resources?.HeaderConcertsAndTickets}
                        </a>

                        <a href={resources?.HeaderEngagementUrl} className="button-header">
                            {resources?.HeaderEngagement}
                        </a>

                        {ShopbasketIcon()}
                    </div>
                </div>
            </div>
        </header >
    );
};

export default Header;